<template id="loading__general">
  <section class="loading__section">
    <div class="loading wave">Cargando</div>
  </section>
</template>